/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addSetting_3 } from '../fn/user-alert-notification-setting/add-setting-3';
import { AddSetting_3$Params } from '../fn/user-alert-notification-setting/add-setting-3';
import { deleteSetting_3 } from '../fn/user-alert-notification-setting/delete-setting-3';
import { DeleteSetting_3$Params } from '../fn/user-alert-notification-setting/delete-setting-3';
import { findByRoleId_1 } from '../fn/user-alert-notification-setting/find-by-role-id-1';
import { FindByRoleId_1$Params } from '../fn/user-alert-notification-setting/find-by-role-id-1';
import { findByTitle_1 } from '../fn/user-alert-notification-setting/find-by-title-1';
import { FindByTitle_1$Params } from '../fn/user-alert-notification-setting/find-by-title-1';
import { getList_4 } from '../fn/user-alert-notification-setting/get-list-4';
import { GetList_4$Params } from '../fn/user-alert-notification-setting/get-list-4';
import { getSetting_4 } from '../fn/user-alert-notification-setting/get-setting-4';
import { GetSetting_4$Params } from '../fn/user-alert-notification-setting/get-setting-4';
import { getSettingsByTitleRoleId_2 } from '../fn/user-alert-notification-setting/get-settings-by-title-role-id-2';
import { GetSettingsByTitleRoleId_2$Params } from '../fn/user-alert-notification-setting/get-settings-by-title-role-id-2';
import { updateSetting_5 } from '../fn/user-alert-notification-setting/update-setting-5';
import { UpdateSetting_5$Params } from '../fn/user-alert-notification-setting/update-setting-5';
import { UserAlertNotificationSetting } from '../models/user-alert-notification-setting';

@Injectable({ providedIn: 'root' })
export class UserAlertNotificationSettingService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getList_4()` */
  static readonly GetList_4Path = '/api/user/notification/alert/setting';

  /**
   * Get List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getList_4()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList_4$Response(params?: GetList_4$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserAlertNotificationSetting>>> {
    return getList_4(this.http, this.rootUrl, params, context);
  }

  /**
   * Get List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getList_4$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList_4(params?: GetList_4$Params, context?: HttpContext): Observable<Array<UserAlertNotificationSetting>> {
    return this.getList_4$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserAlertNotificationSetting>>): Array<UserAlertNotificationSetting> => r.body)
    );
  }

  /** Path part for operation `addSetting_3()` */
  static readonly AddSetting_3Path = '/api/user/notification/alert/setting';

  /**
   * Add Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSetting_3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSetting_3$Response(params: AddSetting_3$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAlertNotificationSetting>> {
    return addSetting_3(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSetting_3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSetting_3(params: AddSetting_3$Params, context?: HttpContext): Observable<UserAlertNotificationSetting> {
    return this.addSetting_3$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAlertNotificationSetting>): UserAlertNotificationSetting => r.body)
    );
  }

  /** Path part for operation `getSetting_4()` */
  static readonly GetSetting_4Path = '/api/user/notification/alert/setting/id/{settingId}';

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetting_4()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting_4$Response(params: GetSetting_4$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAlertNotificationSetting>> {
    return getSetting_4(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetting_4$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetting_4(params: GetSetting_4$Params, context?: HttpContext): Observable<UserAlertNotificationSetting> {
    return this.getSetting_4$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAlertNotificationSetting>): UserAlertNotificationSetting => r.body)
    );
  }

  /** Path part for operation `findByTitle_1()` */
  static readonly FindByTitle_1Path = '/api/user/notification/alert/setting/title/{title}';

  /**
   * Find By Title.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByTitle_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByTitle_1$Response(params: FindByTitle_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserAlertNotificationSetting>>> {
    return findByTitle_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Title.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByTitle_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByTitle_1(params: FindByTitle_1$Params, context?: HttpContext): Observable<Array<UserAlertNotificationSetting>> {
    return this.findByTitle_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserAlertNotificationSetting>>): Array<UserAlertNotificationSetting> => r.body)
    );
  }

  /** Path part for operation `getSettingsByTitleRoleId_2()` */
  static readonly GetSettingsByTitleRoleId_2Path = '/api/user/notification/alert/setting/title/{title}/userId/{userId}';

  /**
   * Get Settings By Title Role Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSettingsByTitleRoleId_2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettingsByTitleRoleId_2$Response(params: GetSettingsByTitleRoleId_2$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAlertNotificationSetting>> {
    return getSettingsByTitleRoleId_2(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Settings By Title Role Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSettingsByTitleRoleId_2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSettingsByTitleRoleId_2(params: GetSettingsByTitleRoleId_2$Params, context?: HttpContext): Observable<UserAlertNotificationSetting> {
    return this.getSettingsByTitleRoleId_2$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAlertNotificationSetting>): UserAlertNotificationSetting => r.body)
    );
  }

  /** Path part for operation `findByRoleId_1()` */
  static readonly FindByRoleId_1Path = '/api/user/notification/alert/setting/userId/{userId}';

  /**
   * Find By Role Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByRoleId_1()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByRoleId_1$Response(params: FindByRoleId_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserAlertNotificationSetting>>> {
    return findByRoleId_1(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Role Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByRoleId_1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByRoleId_1(params: FindByRoleId_1$Params, context?: HttpContext): Observable<Array<UserAlertNotificationSetting>> {
    return this.findByRoleId_1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserAlertNotificationSetting>>): Array<UserAlertNotificationSetting> => r.body)
    );
  }

  /** Path part for operation `updateSetting_5()` */
  static readonly UpdateSetting_5Path = '/api/user/notification/alert/setting/{settingId}';

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSetting_5()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_5$Response(params: UpdateSetting_5$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAlertNotificationSetting>> {
    return updateSetting_5(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSetting_5$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetting_5(params: UpdateSetting_5$Params, context?: HttpContext): Observable<UserAlertNotificationSetting> {
    return this.updateSetting_5$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAlertNotificationSetting>): UserAlertNotificationSetting => r.body)
    );
  }

  /** Path part for operation `deleteSetting_3()` */
  static readonly DeleteSetting_3Path = '/api/user/notification/alert/setting/{settingId}';

  /**
   * Delete Setting.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSetting_3()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSetting_3$Response(params: DeleteSetting_3$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAlertNotificationSetting>> {
    return deleteSetting_3(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Setting.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSetting_3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSetting_3(params: DeleteSetting_3$Params, context?: HttpContext): Observable<UserAlertNotificationSetting> {
    return this.deleteSetting_3$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserAlertNotificationSetting>): UserAlertNotificationSetting => r.body)
    );
  }

}
